import GenericErrorContent from './GenericErrorContent';

export default GenericErrorContent;
